import { useMe } from "@utils/hooks/useMe";
import { ROUTES_E } from "@utils/RoutsName";
import { useContext, useMemo } from "react";
import { useIntl } from "react-intl";
import { MinerContext } from "../MinerContext";
import { IMinerLocationProps } from "./MinerLocation.props";

export enum LOCATION_PARAMS {
  LOCATION = "location",
  MINER = "miner",
  BUILDING = "building",
}

interface IMinerLocationControl {
  readonly canClick: boolean;

  goToMiner(): void;
}

export const useMinerLocationControl = (
  props: IMinerLocationProps
): IMinerLocationControl => {
  const me = useMe();
  const { formatMessage } = useIntl();
  const { miner } = useContext(MinerContext);

  const canClick = useMemo(
    () =>
      !!me?.is_admin &&
      props.children !==
        formatMessage({ id: "machines.table.locations.empty" }),
    [me]
  );

  const goToMiner = () => {
    window.open(
      `${ROUTES_E.LOCATIONS}?${LOCATION_PARAMS.LOCATION}=${miner.location_id}&${LOCATION_PARAMS.MINER}=${miner.id}`,
      "_blank"
    );
  };

  return {
    canClick,

    goToMiner,
  };
};
